/*
 *
 * QuestionnaireLogic constants
 *
 */
import {
  SURVEY_TYPE_DISTRIBUTION_LINK,
  SURVEY_TYPE_PEEQ,
} from 'containers/Survey/constants';

export const BUILD_LOGIC = 'app/QuestionnaireLogic/BUILD_LOGIC';
export const ADD_STATEMENT = 'app/QuestionnaireLogic/ADD_STATEMENT';
export const DELETE_STATEMENT = 'app/QuestionnaireLogic/DELETE_STATEMENT';
export const MOVE_STATEMENT = 'app/QuestionnaireLogic/MOVE_STATEMENT';
export const SET_SCROLL_TO_STATEMENT_ID =
  'app/QuestionnaireLogic/SET_SCROLL_TO_STATEMENT_ID';
export const UPDATE_OUTCOME = 'app/QuestionnaireLogic/UPDATE_OUTCOME';
export const ADD_RULE = 'app/QuestionnaireLogic/ADD_RULE';
export const UPDATE_RULE_OPERATOR =
  'app/QuestionnaireLogic/UPDATE_RULE_OPERATOR';
export const UPDATE_RULE_CONTEXT = 'app/QuestionnaireLogic/UPDATE_RULE_CONTEXT';
export const UPDATE_RULE_QUOTA = 'app/QuestionnaireLogic/UPDATE_RULE_QUOTA';
export const ADD_CONDITION = 'app/QuestionnaireLogic/ADD_CONDITION';
export const DELETE_CONDITION = 'app/QuestionnaireLogic/DELETE_CONDITION';
export const UPDATE_CONDITION = 'app/QuestionnaireLogic/UPDATE_CONDITION';
export const ADD_UNCONDITIONAL_HIDE_ANSWER =
  'app/QuestionnaireLogic/ADD_UNCONDITIONAL_HIDE_ANSWER';
export const REMOVE_UNCONDITIONAL_HIDE_ANSWER =
  'app/QuestionnaireLogic/REMOVE_UNCONDITIONAL_HIDE_ANSWER';

export const THEMES = {
  DEFAULT: 'default',
  GREEN: 'green',
};

export const SURVEY_TYPES_EDIT_QUESTIONNAIRE_LOGIC = [
  SURVEY_TYPE_DISTRIBUTION_LINK,
  SURVEY_TYPE_PEEQ,
];

export const HIDDEN_VARIABLES_TABS = {
  VARIABLES: 'hidden-variables-tab',
  RULES: 'hidden-variables-rules-tab',
};
